import {Web3AuthSignatureGroup} from '#/hooks/use-web3auth-signature-group';
import {ApiBodyWithoutSignature, fetchFromApiRoute, fetchFromApiRouteWithSignature} from '#/utils/fetch-utils';
import {ApiLandComments, apiLandComments} from 'shareland-common';

const get = async (
  params: ApiLandComments['get']['paramsDictionary'] & ApiLandComments['get']['reqQuery'],
): Promise<ApiLandComments['get']['resBody']['data']> => {
  const {land_token_symbol, ...reqQuery} = params;

  const res = await fetchFromApiRoute<ApiLandComments['get']>(apiLandComments.endpoints.get, {
    paramsDictionary: {land_token_symbol},
    reqBody: null,
    reqQuery,
  });

  return res ?? null;
};

const create = async (
  params: ApiBodyWithoutSignature<ApiLandComments['create']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiLandComments['create']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiLandComments['create']>(
    apiLandComments.endpoints.create,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

const likeDislike = async (
  params: ApiBodyWithoutSignature<ApiLandComments['likeDislike']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiLandComments['likeDislike']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiLandComments['likeDislike']>(
    apiLandComments.endpoints.likeDislike,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

const flag = async (
  params: ApiBodyWithoutSignature<ApiLandComments['flag']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiLandComments['flag']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiLandComments['flag']>(
    apiLandComments.endpoints.flag,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

const deleteComment = async (
  params: ApiBodyWithoutSignature<ApiLandComments['delete']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiLandComments['delete']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiLandComments['delete']>(
    apiLandComments.endpoints.delete,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

export const landCommentsRequests = {
  get,
  create,
  likeDislike,
  flag,
  delete: deleteComment,
};
